import { Injectable } from "@angular/core";
import { ApiService } from "../../services/api.service";

@Injectable()

export class MenuService {

    constructor(private api: ApiService) {}

    getTree() {
        return this.api.get('menu');
    }
}


// WEBPACK FOOTER //
// ./src/app/layouts/menu/menu.service.ts